import React from 'react';
import McpConsole from '../components/McpConsole';
import PageHeader from '../components/shell/PageHeader';

const AgentToolsPage: React.FC = () => (
    <>
        <PageHeader
            title="Agent e MCP"
            description="Strumenti tecnici per interrogare il sistema diagnostico e preparare l'integrazione con gli agent."
        />

        <div className="alert alert-warning border small">
            La console esegue chiamate reali agli endpoint amministrativi. Usala per ispezione e diagnosi;
            l'applicazione automatica di modifiche resta disabilitata finché non è disponibile il workflow approvativo.
        </div>

        <McpConsole />
    </>
);

export default AgentToolsPage;
